import React,{useEffect,useState} from 'react';
import {getEmailArchive,advanceEmailArchive} from '@/lib/apiClient';
import {userError} from '@/lib/userError';

export default function EmailArchiveImport({onChanged}) {
 const [data,setData]=useState(null),[busy,setBusy]=useState(false),[error,setError]=useState(''),[hidden,setHidden]=useState(false);
 const read=async()=>{
  try{const value=await getEmailArchive();setData(value);return value;}
  catch(e){if([403,409].includes(e?.response?.status))setHidden(true);else setError(userError(e,'Tuonnin tilaa ei saatu tarkistettua.'));return null;}
 };
 useEffect(()=>{let active=true;getEmailArchive().then(value=>{if(active)setData(value);}).catch(e=>{if(active){if([403,409].includes(e?.response?.status))setHidden(true);else setError('Tuonnin tilaa ei saatu tarkistettua.');}});return()=>{active=false;};},[]);
 const next=async()=>{
  if(busy||!data?.enabled)return;
  setBusy(true);setError('');
  try{setData(await advanceEmailArchive({revision:data.revision}));await onChanged?.();}
  catch(e){setError(userError(e,'Tuontierän tulosta ei voitu vahvistaa. Tarkista tila ennen uutta yritystä.'));await read();}
  finally{setBusy(false);}
 };
 if(hidden)return null;
 const working=data?.phase==='running',done=data?.phase==='complete';
 return <section aria-label="Vanhemman Saapuneet-postin tuonti" className="mt-3 rounded-xl border border-border p-3 text-sm">
  <h3 className="font-semibold">Vanhempi Saapuneet-posti</h3>
  {data&&!data.enabled&&<p>Tuonti on valmisteilla. Nykyinen yhteys tarvitsee ensin jatkohaun tuen.</p>}
  {data?.enabled&&<>
   <p>Haetaan enintään 10 viestiä kerrallaan. Käyttää nykyisen Make-yhteyden suorituksia. Ei AI-analyysiä.</p>
   <p role="status">{done?'Tämän Saapuneet-kansion tuontikierroksen sivut on haettu.':working?'Tuontierä on käynnissä. Tarkista tila ennen jatkamista.':data.phase==='interrupted'?'Edellinen tuontierä keskeytyi. Voit yrittää samaa erää uudelleen.':data.phase==='failed'?'Edellinen erä jäi kesken. Jatkokohta säilyi.':'Voit hakea seuraavan erän.'}</p>
   <p>Tallennettuja eriä {data.pages} · käsiteltyjä viestejä {data.processed}. Sama viesti voi sisältyä useaan erään.</p>
   <p className="text-xs text-muted-foreground">Tämä tuonti kattaa Saapuneet-kansion, ei koko postilaatikkoa tai liitteitä. Viestejä ei lähetetä eikä siirretä.</p>
   {!done&&<button className="min-h-11 text-primary" disabled={busy||working} onClick={next}>{busy?'Haetaan…':['failed','interrupted'].includes(data.phase)?'Yritä samaa erää uudelleen':'Hae seuraavat enintään 10 viestiä'}</button>}
  </>}
  {error&&<p role="alert">{error}</p>}
  <button className="min-h-11 text-primary ml-3" disabled={busy} onClick={()=>{setError('');read();}}>Tarkista tuonnin tila</button>
 </section>;
}
